import React from 'react';
import CIcon from '@coreui/icons-react';
import { CBadge, CLink } from '@coreui/react';
import CSwitch from '../../../../../migration/CSwitch';
import Tippy from '@tippyjs/react';

const ViewScheduleCard = ({ viewReport, index, onEdit, onDelete, onStatus, isManageScheduled, onOpenSchedule }) => {
    const countScheduleEmailList = viewReport.sendEmail ? (typeof viewReport?.emailRecipients === 'string' ? JSON.parse(viewReport?.emailRecipients) : viewReport?.emailRecipients) : [];
    const countScheduleEmail = countScheduleEmailList?.length || 0;

     const formatSpecificDayLabel = (specificDay) => {
          let str = specificDay;
          if (str !== 'First Monday') str = specificDay + ' Day';
          return `On ${str} of the Month`;
     };

     const desTooltipSchedule = () => {
          const SPECIFIC_DAY = {
               first: 'First',
               last: 'Last',
               firstMonday: 'First Monday',
          };
          let content = '';
          switch (viewReport.schedule) {
               case 'daily':
                    content = 'Everyday.';
                    break;
               case 'weekly':
                    const daysOfWeek = Array.isArray(viewReport.daysOfWeek) ? viewReport.daysOfWeek : JSON.parse(viewReport.daysOfWeek);
                    content = `Every ${daysOfWeek.join(', ')}.`;
                    break;
               case 'monthly':
                    content = formatSpecificDayLabel(SPECIFIC_DAY[viewReport.specificDay]);
                    break;
               case 'quarterly':
                    content = `On ${SPECIFIC_DAY[viewReport.specificDay]} Day of the Quarter.`;
                    break;
               default:
                    break;
          }

          return content;
     };

    return (
         <div key={index} className="row-rule d-flex justify-content-between">
              <div className="info-wrap d-flex justify-content-between align-items-center py-2">
                   <div className="info-title">
                        <h4>{viewReport.name}</h4>
                        <div className="tooltip-schedule-card">
                             <Tippy
                                  content={
                                       <div className="block-tooltip-text email-block-tooltip text-start">
                                            <span>Delivery Schedule: {desTooltipSchedule()}</span>
                                            <div className="email-list-tooltip text-start">
                                                 <span>Recipients:</span>
                                             <ul>
                                                 {countScheduleEmailList.map((email, idx) => {
                                                     return <li key={email.value || idx}>{email.value}</li>;
                                                 })}
                                             </ul>
                                            </div>
                                       </div>
                                  }
                                  interactive="true"
                             >
                                  <CIcon icon="icon-info" height={14} />
                             </Tippy>
                        </div>
                   </div>
              </div>

              <div className="options-wrapper d-flex">
                   {!isManageScheduled && (
                        <div className="option-item hover-show-tooltip save-report-bell notification-bell pl-0 mr-0" >
                             <CLink className="option" onClick={onOpenSchedule || onEdit}>
                                  <CIcon icon="cilEnvelopeClosed" />

                                  {countScheduleEmail > 0 && (
                                       <CBadge
                                            shape="pill"
                                            color="danger"
                                            className={`${countScheduleEmail > 99 ? 'big-number' : ''} position-absolute right-5px`}
                                       >
                                            {countScheduleEmail}
                                       </CBadge>
                                  )}
                             </CLink>

                             <div className="block-tooltip">
                                  <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                  <div className="block-tooltip-text">
                                       <p>Delivery Schedule</p>
                                  </div>
                             </div>
                        </div>
                   )}

                   {onDelete && (
                        <div className="option-item hover-show-tooltip">
                             <CLink className="option option-item-delete" onClick={onDelete}>
                                  <CIcon icon="iconDeleteField" className="icon-delete pointer" />
                             </CLink>

                             <div className="block-tooltip">
                                  <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                  <div className="block-tooltip-text">
                                       <p>Delete Schedule</p>
                                  </div>
                             </div>
                        </div>
                   )}

                   {onEdit && (
                        <div className="option-item hover-show-tooltip">
                             <CLink className="option text-primary" onClick={onEdit}>
                                  <CIcon icon="icon-pencil" height={14} />
                             </CLink>

                             <div className="block-tooltip">
                                  <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                  <div className="block-tooltip-text">
                                       <p>Edit Schedule</p>
                                  </div>
                             </div>
                        </div>
                   )}

                   {onStatus && (
                        <div className="option-item switch-item hover-show-tooltip">
                             <span className="option">
                                  <CSwitch
                                       color={viewReport.status ? 'success' : 'light'}
                                       checked={viewReport.status === 'active'}
                                       value={viewReport.status ? 'active' : 'inactive'}
                                       onChange={onStatus}
                                       shape="pill"
                                       tabIndex="0"
                                       size="sm"
                                  />
                             </span>

                             <div className="block-tooltip">
                                  <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                  <div className="block-tooltip-text">
                                       <p>{viewReport.status === 'active' ? 'Inactive Schedule' : 'Active Schedule'}</p>
                                  </div>
                             </div>
                        </div>
                   )}
              </div>
         </div>
    );
}

export default ViewScheduleCard;
